import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Heart } from "lucide-react";
import { IMAGES, DONATION_URL } from "@/lib/siteData";

const links = [
  { label: "Anlass", href: "#anlass" },
  { label: "Wirkung", href: "#wirkung" },
  { label: "Programm", href: "#programm" },
  { label: "Anmelden", href: "#anmelden" },
];

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (e, href) => {
    e.preventDefault();
    if (href === "#top") { window.scrollTo({ top: 0, behavior: "smooth" }); return; }
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, delay: 1.8, ease: [0.76, 0, 0.24, 1] }}
      className="fixed top-0 inset-x-0 z-50"
      data-testid="site-nav"
    >
      <div
        className={`mx-auto max-w-7xl mt-3 px-4 sm:px-6 transition-all duration-500 ${
          scrolled ? "" : ""
        }`}
      >
        <div
          className={`flex items-center justify-between rounded-full border px-4 sm:px-6 py-2.5 transition-all duration-500 ${
            scrolled
              ? "border-white/10 bg-ink/70 backdrop-blur-xl"
              : "border-transparent bg-transparent"
          }`}
        >
          <a href="#top" onClick={(e) => go(e, "#top")} className="flex items-center gap-2" data-testid="nav-logo">
            <img src={IMAGES.jciLogo} alt="JCI Zürich Flughafenregion" className="h-8 sm:h-9 w-auto rounded-md bg-white/95 px-2 py-1.5" />
          </a>

          <nav className="hidden md:flex items-center gap-9">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={(e) => go(e, l.href)}
                className="text-sm text-ivory/70 hover:text-ivory transition-colors duration-300 tracking-wide"
                data-testid={`nav-link-${l.label.toLowerCase()}`}
              >
                {l.label}
              </a>
            ))}
          </nav>

          <motion.a
            whileTap={{ scale: 0.97 }}
            href={DONATION_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="group inline-flex items-center gap-2 rounded-full bg-magenta px-5 py-2 text-sm font-medium text-white transition-colors duration-300 hover:bg-violet"
            data-testid="nav-donate-button"
          >
            <Heart size={15} className="transition-transform duration-300 group-hover:scale-125" />
            Spenden
          </motion.a>
        </div>
      </div>
    </motion.header>
  );
};
